import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Tabs,
  Select,
  Input,
  Upload,
  Timeline,
} from "antd";
import DataTable from '@/components/DataTable';
import {
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { get_Next_Ticket, get_ticket_timeline } from '@/utils/api';
import { useLocation } from "react-router-dom";

const { Option } = Select;

const TicketDetails = () => {
  const location = useLocation();
  const ticketnew = location.state?.data;
  // Get the ticket data from the location state
  console.log(ticketnew);
  const ticket_id = ticketnew?.ticket_id;

  const workflow = ticketnew?.workflow;
  const current_stage_id = ticketnew?.current_stage_id;

  const [activeTab, setActiveTab] = useState("timeline");
  const [ticket, setTicket] = useState({});
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        get_Next_Ticket(
          { current_stage_id, issue_type_id: workflow },
          (response) => {
            console.log("Full API Response:", response.data);
            setTicket(response.data);
          }
        );
      } catch (e) {
        setError(e);
        console.error("Fetching data failed", e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [current_stage_id, workflow]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        get_ticket_timeline({ ticket_id: ticket_id }, (response) => {
          console.log("Full API Response:", response.data);
          setTimeline(response.data?.data);
        });
      } catch (e) {
        setError(e);
        console.error("Fetching data failed", e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [ticket_id]);

  const ticketData = [
    { key: "Title", value: ticketnew?.title || "N/A" },
    { key: "Ticket Id", value: ticketnew?.ticket_id || "N/A" },
    { key: "Batch ID", value: ticketnew?.batch_id || "N/A" },
    { key: "Batch Number", value: ticketnew?.batch_number || "N/A" },
    { key: "Operation Name", value: ticketnew?.operation_name || "N/A" },
    { key: "Priority", value: ticketnew?.priority || "N/A" },
    { key: "Department", value: ticketnew?.department || "N/A" },
    { key: "Current Stage", value: ticketnew?.current_stage || "N/A" },
    { key: "Created At", value: ticketnew?.created_at || "N/A" },
    { key: "Status Updated At", value: ticketnew?.status_updated_at || "N/A" },
    { key: "Is Completed", value: ticketnew?.is_completed ? "Yes" : "No" },
    {
      key: "Ticket History",
      value: (
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          style={{ marginTop: 16 }}
        >
          Report
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: 20, display: "flex", gap: 20 }}>
      <Card title="Ticket Details" style={{ flex: 0.6 }}>
        <DataTable
          data={ticketData}
          pagination={false}
          showHeader={false}
          size="middle"
          height={null}
          columns={[
            {
              title: "",
              dataIndex: "key",
              key: "key",
              width: 150,
              render: (text) => <strong>{text}</strong>,
            },
            { title: "", dataIndex: "value", key: "value" },
          ]}
        />
      </Card>

      <Card
        title="Actions & Timeline"
        style={{ flex: 0.4 }}
      >
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <Tabs.TabPane tab="Timeline" key="timeline">
            <Timeline>
              {timeline.length > 0 ? (
                timeline.map((item, index) => (
                  <Timeline.Item key={index} color="green">
                    <div className="flex flex-col space-y-1">
                      <strong className="text-lg text-blue-600">
                        {item.status_name.trim() || "N/A"}
                      </strong>

                      <div className="flex justify-between text-gray-600">
                        <span className="font-semibold">Performed by:</span>
                        <span>{item.performaed_by || "N/A"}</span>
                      </div>

                      <div className="flex justify-between text-gray-500 text-sm">
                        <span className="font-semibold">Time:</span>
                        <span>{item.dt || "N/A"}</span>
                      </div>
                    </div>
                  </Timeline.Item>
                ))
              ) : (
                <Timeline.Item color="gray">
                  No timeline data available.
                </Timeline.Item>
              )}
            </Timeline>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default TicketDetails;
